import React from 'react';
import I18n from 'i18n-js';
import { I18N } from '@reverbdotcom/commons/src/components/translate';
import {
  RCBanner,
  RCBox,
  RCButtonLink,
  RCFlex,
  RCText,
  useMediaQuery,
} from '@reverbdotcom/cadence/components';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';
import { Paths } from '../shared/url_helpers';
import ShieldLight from '../../../images/shield-light.svg';

function DesktopBanner() {
  return (
    <RCBanner
      title={I18n.t('discovery.reverbPaymentsExpansionSellerOrdersBanner.title')}
      image={ShieldLight}
      content={
        <>
          <I18N text="discovery.reverbPaymentsExpansionSellerOrdersBanner.subtitle" />
          {' '}
          <I18N text="discovery.reverbPaymentsExpansionSellerOrdersBanner.moreText" />
        </>
      }
      cta={
        <CoreLink to={Paths.shopPoliciesEdit.expand({})} target="_blank" rel="noopener noreferrer">
          {I18n.t('discovery.reverbPaymentsExpansionSellerOrdersBanner.updatePayoutSettings')}
        </CoreLink>
      }
      theme="plain"
    />
  );
}

function MobileBanner() {
  return (
    <RCBox
      borderRadius="rc-border-radius-md"
      display="block"
      padding="rc-space-6"
      variant="subtle"
    >
      <RCFlex direction="col">
        <RCFlex gap="3">
          <img src={ShieldLight} alt="" style={{ width: '5.6rem' }} />
          <RCText.Utility weight="bold" size="450">
            {I18n.t('discovery.reverbPaymentsExpansionSellerOrdersBanner.title')}
          </RCText.Utility>
        </RCFlex>
        <RCText size="350">
          {I18n.t('discovery.reverbPaymentsExpansionSellerOrdersBanner.subtitle')}
        </RCText>
        <RCButtonLink
          renderLink={c => <CoreLink to={Paths.shopPoliciesEdit.expand({})}>{c}</CoreLink> as React.ReactElement}
          variant="filled"
        >
          {I18n.t('discovery.reverbPaymentsExpansionSellerOrdersBanner.updatePayoutSettings')}
        </RCButtonLink>
      </RCFlex>
    </RCBox>

  );
}

function ReverbPaymentsExpansionSellerOrdersBanner() {
  const isMobile = useMediaQuery('mobile');

  return (
    <div className="reverb-payments-expansion-seller-orders-banner">
      {isMobile ? <MobileBanner /> : <DesktopBanner />}
    </div>
  );
}

export default ReverbPaymentsExpansionSellerOrdersBanner;
